;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .controller('InputToggleSelectorController', InputToggleSelectorController)

  /* @ngInject */
  function InputToggleSelectorController ($scope, UdsModalService) {
    const getUpgradeCompanyPlanDialogController = () => import('../../dialogs/upgrade-company-plan/upgrade-company-plan-dialog.controller')

    const api = {
      _openUpgradeCompanyPlanDialog,
      getUpgradeCompanyPlanDialogController
    }
    this.getApi = () => api

    $scope.handleSelectOption = function (option) {
      const toggleGroups = $scope.options[1]
      if (toggleGroups.pricing && option === 'GROUPS') {
        api._openUpgradeCompanyPlanDialog(toggleGroups.pricingData)
      } else {
        $scope.model = option
      }
    }

    function _openUpgradeCompanyPlanDialog (pricingData) {
      api.getUpgradeCompanyPlanDialogController().then(({ UpgradeCompanyPlanDialogController }) => {
        const upgradeCompanyPlanDialog = UdsModalService.createModal({
          controller: UpgradeCompanyPlanDialogController,
          modalName: 'upgradeCompanyPlanDialog',
          data: {
            featureName: pricingData.name,
            featureSlug: pricingData.slug
          }
        })
        upgradeCompanyPlanDialog.open()
      })
    }
  }
})()
